import React from 'react';
import c from 'classnames';
import CommentBoxContentWrapper from '../../lego/CommentBoxContentWrapper';
import s from './CommentBoxLayout.scss';
/**
 * Our comment box's layout.
 */
var CommentBoxLayout = React.forwardRef(function (_a, ref) {
    var above = _a.above, avatar = _a.avatar, content = _a.content, className = _a.className;
    return (React.createElement("div", { className: c(s['root'], className), ref: ref },
        above && React.createElement("div", { className: s['above'] }, above),
        React.createElement("div", { className: s['main'] },
            avatar && React.createElement("div", { className: s['avatar'] }, avatar),
            React.createElement(CommentBoxContentWrapper, { className: s['content'] }, content))));
});
CommentBoxLayout.displayName = 'CommentBoxLayout';
export default CommentBoxLayout;
//# sourceMappingURL=CommentBoxLayout.js.map